export const PATHS = {
  signIn: '/sign-in',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  entities: '/entities',
  entity: (id = ':id') => `/entities/${id}`,
};
